export default __webpack_public_path__ + "static/media/Destination2.b85bfb44.png";